import React, { useState, useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import {
  $Skeleton,
  $Button,
  $Search,
  $TableTree,
} from "us.common/components/antd";
import { useTranslation } from "react-i18next";
import * as Action from "us.common/actions";
import { DEFAULT_COUNTRY_CODE } from "us.common/constants";
import { IOnFilter, IOnSort } from "us.common/components/antd/TableTree";
import "./MunicipalSelection.scss";
import { RootState } from "us.helper/types";
import { useFormikContext } from "formik";

const MunicipalSelection: React.FC<PropsFromRedux> = (props) => {
  const { t } = useTranslation();
  const {
    municiples,
    isMunicipalsLoading,
    existingCode,
    getMunicipals,
    clearPostalData,
  } = props;
  const [selectedMunicipality, setSelectedMunicipality] = useState<any>();
  const { values, setFieldValue } = useFormikContext<any>();
  const [sortedInfo, setSortedInfo] = useState<{
    columnKey: string;
    order: any;
  }>({
    columnKey: "",
    order: "",
  });

  useEffect(() => {
    setTimeout(() => {
      setSortedInfo({
        columnKey: "",
        order: "",
      });
    }, 1500);
    // clearPostalData({});
  }, [municiples]);

  const onSelectChange = (selectedRowKeys: any, selectedRows: any[]) => {
    const selectedMunicipality = selectedRows[0];
    setSelectedMunicipality(selectedMunicipality);
  };

  const columns: any = [
    {
      title: t("US.COLLECTION.COMMON:ENTITYSELECTION.MUNICIPALITY_CODE"),
      dataIndex: "municipalityCode",
      key: "municipalityCode",
      width: 200,
      customSorter: (a: any, b: any) => a - b,
      customFilter: true,
    },
    {
      title: t("US.COLLECTION.COMMON:ENTITYSELECTION.MUNICIPALITY_NAME"),
      dataIndex: "municipalityName",
      key: "municipalityName",
      customSorter: (a: any, b: any) => a?.localeCompare(b),
      customFilter: true,
    },
    {
      title: t("US.COLLECTION.COMMON:ENTITYSELECTION.COUNTRY"),
      dataIndex: "countryName",
      key: "countryName",
      customSorter: (a: any, b: any) => a?.localeCompare(b),
      customFilter: true,
    },
  ];

  const rowSelection = {
    onChange: onSelectChange,
    hideDefaultSelections: true,
  };

  const handleSort: IOnSort = (sortData, dataSource) => {
    return sortData(dataSource);
  };

  const handleFilter: IOnFilter = (searchData, dataSource) => {
    return searchData(dataSource);
  };

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    setSortedInfo(sorter);
  };

  const uppdatePostalData = (record: any) => {
    setFieldValue("country", record.countryName?.trim() || "");
    setFieldValue("countryCode", record.countryCode?.trim() || "");
    setFieldValue("countyCode", record.municipalityCode?.trim() || "");
    setFieldValue("countyName", record.municipalityName?.trim() || "");
    setFieldValue("step", 1);
  };

  return (
    <div className="select-municipal">
      <$Search
        data-testid="select-municipal"
        name="code"
        enterButton
        size="small"
        placeholder="Search"
        className="mb-3"
        disabled={isMunicipalsLoading}
        onSearch={(e: any) => {
          getMunicipals({
            countryCode: "",
            searchText: e === "" ? "" : e,
          });
        }}
        onPressEnter={(e: any) =>
          getMunicipals({
            countryCode: "",
            searchText: e.target.value === "" ? "" : e.target.value,
          })
        }
        allowClear={true}
      />
      <$Skeleton loading={isMunicipalsLoading} active paragraph={{ rows: 3 }}>
        <$TableTree
          data-testid="municipal-table"
          rowSelection={{ type: "radio", ...rowSelection }}
          rowKey={(record) => record.municipalityId}
          data={municiples}
          size="small"
          className=""
          onSort={handleSort}
          onFilter={handleFilter}
          filterOnType={true}
          resetOnSourceChange={true}
          bordered
          pagination={{ defaultPageSize: 20 }}
          columns={columns}
          onChange={handleTableChange}
          onRow={(record: any, rowIndex: any) => {
            return {
              onDoubleClick: (event: any) => {
                setSelectedMunicipality(record);
                uppdatePostalData(record);
              },
            };
          }}
          firstColSkipFilterProps={-1}
          scroll={{ x: "100%", y: "calc(100vh - 350px)" }}
        />
      </$Skeleton>
      <div className="drawer-footer-fixed align-content-center justify-content-end">
        <$Button
          className="mr-2"
          type="primary"
          disabled={!selectedMunicipality}
          onClick={() => {
            uppdatePostalData(selectedMunicipality);
          }}
          data-testid="ok-btn"
        >
          {t("US.COMMON:COMMON.OK")}
        </$Button>
        <$Button
          onClick={() => {
            setFieldValue("step", 1);
          }}
        >
          {t("US.COMMON:COMMON.CANCEL")}
        </$Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const { entityDetails } = state;
  const { municiples, AddPostalFormData, existingCode, isMunicipalsLoading } =
    entityDetails;
  return {
    municiples,
    AddPostalFormData,
    existingCode,
    isMunicipalsLoading,
  };
};

const mapDispatchToProps = {
  getMunicipals: Action.entity.getMunicipals,
  clearPostalData: Action.entity.clearPostalData,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(MunicipalSelection);
